import EditorBase from '../../EditorBase'

export const EditorText = (props: any) => {
	const tagName = props.tagName || 'p'
	return <EditorBase {...props} tagName={tagName} />
}
